const getOptimizedImageUrl = (url: string, imageWidth = 620) => {
  if (typeof url !== 'string') {
    return null;
  }

  if (url === '') {
    return null;
  }

  const splitUrl = url.split('upload/');
  if (splitUrl.length < 2) {
    return url;
  }

  return `${splitUrl[0]}upload/w_${imageWidth}/${splitUrl[1]}`;
};

export { getOptimizedImageUrl };
